import service from '@/api/service/service';
import qs from "qs";

// ...
export function getDisplayClassAllInfo(params) {
    return service({
        url: "/api/statistical/class_statistical.json",
        method: 'get',
        params
    });
}

// 培训班监控
export function getDisplayClassTable(params) {
    return service({
        url: "/api/statistical/class_log_statistical.json",
        method: "GET",
        params
    })
}

// 教案统计
export function getTutorialAll() {
    return service({
        url: "/api/statistical/plan_statistical.json",
        method: "GET"
    })
}

// 加载用户登录统计
export function getUserLoginData(params) {
    return service({
        url: "/api/statistical/user_statistical.json",
        method:'GET',
        params
    })
}


